// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var LlmModel$ReactHooksTemplate = require("./llmModel.res.js");
var LlmProvider$ReactHooksTemplate = require("./llmProvider.res.js");

function empty(param) {
  return {
          id: undefined,
          name: "",
          description: "",
          llmProvider: undefined,
          llmModel: undefined,
          integrationId: undefined,
          providerId: undefined,
          modelId: undefined
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function description(t) {
  return t.description;
}

function llmProvider(t) {
  return t.llmProvider;
}

function llmModel(t) {
  return t.llmModel;
}

function integrationId(t) {
  return t.integrationId;
}

function providerId(t) {
  return t.providerId;
}

function modelId(t) {
  return t.modelId;
}

function setId(t, id) {
  return {
          id: id,
          name: t.name,
          description: t.description,
          llmProvider: t.llmProvider,
          llmModel: t.llmModel,
          integrationId: t.integrationId,
          providerId: t.providerId,
          modelId: t.modelId
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          description: t.description,
          llmProvider: t.llmProvider,
          llmModel: t.llmModel,
          integrationId: t.integrationId,
          providerId: t.providerId,
          modelId: t.modelId
        };
}

function setDescription(t, desc) {
  return {
          id: t.id,
          name: t.name,
          description: desc,
          llmProvider: t.llmProvider,
          llmModel: t.llmModel,
          integrationId: t.integrationId,
          providerId: t.providerId,
          modelId: t.modelId
        };
}

function setLlmProvider(t, provider) {
  return {
          id: t.id,
          name: t.name,
          description: t.description,
          llmProvider: provider,
          llmModel: t.llmModel,
          integrationId: t.integrationId,
          providerId: t.providerId,
          modelId: t.modelId
        };
}

function setLlmModel(t, model) {
  return {
          id: t.id,
          name: t.name,
          description: t.description,
          llmProvider: t.llmProvider,
          llmModel: model,
          integrationId: t.integrationId,
          providerId: t.providerId,
          modelId: t.modelId
        };
}

function setIntegrationId(t, v) {
  return {
          id: t.id,
          name: t.name,
          description: t.description,
          llmProvider: t.llmProvider,
          llmModel: t.llmModel,
          integrationId: v,
          providerId: t.providerId,
          modelId: t.modelId
        };
}

function fromJson(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          description: Json_decode.field("description", Json_decode.string, json),
          llmProvider: Json_decode.optional((function (param) {
                  return Json_decode.field("llm_provider", LlmProvider$ReactHooksTemplate.fromJson, param);
                }), json),
          llmModel: Json_decode.optional((function (param) {
                  return Json_decode.field("llm_model", LlmModel$ReactHooksTemplate.decodeModels, param);
                }), json),
          integrationId: Json_decode.optional((function (param) {
                  return Json_decode.field("integration_id", Json_decode.$$int, param);
                }), json),
          providerId: Json_decode.optional((function (param) {
                  return Json_decode.field("llm_provider_id", Json_decode.$$int, param);
                }), json),
          modelId: Json_decode.optional((function (param) {
                  return Json_decode.field("llm_model_id", Json_decode.$$int, param);
                }), json)
        };
}

function toJson(f) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), f.id)
              ],
              tl: {
                hd: [
                  "name",
                  f.name
                ],
                tl: {
                  hd: [
                    "description",
                    f.description
                  ],
                  tl: {
                    hd: [
                      "feature_id",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), f.id)
                    ],
                    tl: {
                      hd: [
                        "llm_provider_id",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), Belt_Option.flatMap(f.llmProvider, LlmProvider$ReactHooksTemplate.id))
                      ],
                      tl: {
                        hd: [
                          "llm_model_id",
                          Json_encode.nullable((function (prim) {
                                  return prim;
                                }), Belt_Option.flatMap(f.llmModel, LlmModel$ReactHooksTemplate.id))
                        ],
                        tl: {
                          hd: [
                            "llm_provider",
                            Belt_Option.getWithDefault(Belt_Option.map(f.llmProvider, LlmProvider$ReactHooksTemplate.toJson), null)
                          ],
                          tl: {
                            hd: [
                              "llm_model",
                              Belt_Option.getWithDefault(Belt_Option.map(f.llmModel, LlmModel$ReactHooksTemplate.encodeModel), null)
                            ],
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

exports.empty = empty;
exports.id = id;
exports.name = name;
exports.description = description;
exports.llmProvider = llmProvider;
exports.llmModel = llmModel;
exports.integrationId = integrationId;
exports.providerId = providerId;
exports.modelId = modelId;
exports.setId = setId;
exports.setName = setName;
exports.setDescription = setDescription;
exports.setLlmProvider = setLlmProvider;
exports.setLlmModel = setLlmModel;
exports.setIntegrationId = setIntegrationId;
exports.fromJson = fromJson;
exports.toJson = toJson;
/* No side effect */
